import Grid from '@material-ui/core/Grid';
import Button from 'components/button/Button';
import { InputField } from "components/InputField";
import MyButton from "components/MyButton";
import { TextareaField } from "components/TextareaField";
import React from 'react';
import './index.scss';

export const AudienceInformation = ({onClick,formik}) => {

    return (
        <div className='audience_information_wrapper'>
        <Grid container spacing={5}>
        <Grid item xs={12} sm={12} md={12}>
        <InputField
                type="text"
                title="Name"
                mandatory
                {...{
                  formik,
                  name: 'Name',
                  placeholder: 'Name',
                  value:  formik?.values?.name,
                }}
                handleChange={(e) => {
                  console.log('nammmmm')
                  formik.setFieldValue('name', e?.target?.value);
                }}
                inputClassName="donation__input"
      />
        </Grid>
        <Grid item xs={12} sm={12} md={12}>
        <TextareaField
                {...{
                  formik,
                  title: "Add Description",
                  name: `note`,
                  placeholder: "Discription text",
                  style: { resize: "none" },
                  checkValidation: true,
                  onChange: (value) => {
                    formik.setFieldValue(`note`, value);
                  },
                }}
                defaultValue={formik?.values?.note
                }
              />
        </Grid>
      </Grid><br/><br/>
      <div className="buttons-inside-audience-info" style={{justifyContent:'end'}}>
        <Button
           style={{ width: "100px", marginBottom: "25px" }}
           onClick={()=>onClick()}
           disabled={!formik?.values?.name?.trim()}
           variant="primary"
           size="md"
        >
          <span>Next</span>
        </Button>
      </div>
        </div>
    );
};
